import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FloatingCTA from '@/components/feature/FloatingCTA';

type Category = 'all' | 'courses' | 'products' | 'workshops' | 'services';

interface Product {
  id: number;
  category: Exclude<Category, 'all'>;
  title: string;
  desc: string;
  price: string;
  image: string;
  cta: string;
  link: string;
  badge?: string;
}

const ProductsPage = () => {
  const { t } = useTranslation();
  const [activeCategory, setActiveCategory] = useState<Category>('all');

  const products: Product[] = [
    {
      id: 1,
      category: 'courses',
      title: 'Social Media Mastery',
      desc: t('products.items.m1.desc'),
      price: '$97',
      image: 'https://readdy.ai/api/search-image?query=online%20course%20social%20media%20marketing%20digital%20education%20laptop%20screen%20glowing%20purple%20blue%20neon%20modern%20workspace%20professional&width=600&height=380&seq=prod1&orientation=landscape',
      cta: t('products.common.buyNow'),
      link: 'https://stan.store',
      badge: t('products.items.m1.badge'),
    },
    {
      id: 2,
      category: 'courses',
      title: 'AI Business Automation',
      desc: t('products.items.m2.desc'),
      price: '$147',
      image: 'https://readdy.ai/api/search-image?query=artificial%20intelligence%20business%20automation%20robot%20digital%20tools%20futuristic%20purple%20blue%20glowing%20technology%20modern&width=600&height=380&seq=prod2&orientation=landscape',
      cta: t('products.common.buyNow'),
      link: 'https://stan.store',
      badge: t('products.common.new'),
    },
    {
      id: 3,
      category: 'courses',
      title: t('products.items.m3.title'),
      desc: t('products.items.m3.desc'),
      price: '$127',
      image: 'https://readdy.ai/api/search-image?query=digital%20marketing%20course%20online%20learning%20entrepreneur%20woman%20laptop%20purple%20neon%20glow%20modern%20education&width=600&height=380&seq=prod9&orientation=landscape',
      cta: t('products.common.buyNow'),
      link: 'https://stan.store',
    },
    {
      id: 4,
      category: 'products',
      title: 'Content Calendar Template',
      desc: t('products.items.m4.desc'),
      price: '$27',
      image: 'https://readdy.ai/api/search-image?query=content%20calendar%20digital%20planner%20template%20social%20media%20schedule%20organized%20colorful%20modern%20design%20purple&width=600&height=380&seq=prod3&orientation=landscape',
      cta: t('products.common.buyNow'),
      link: 'https://stan.store',
    },
    {
      id: 5,
      category: 'products',
      title: t('products.items.m5.title'),
      desc: t('products.items.m5.desc'),
      price: '$47',
      image: 'https://readdy.ai/api/search-image?query=brand%20kit%20design%20templates%20logo%20colors%20typography%20digital%20product%20modern%20elegant%20purple%20blue%20gradient&width=600&height=380&seq=prod4&orientation=landscape',
      cta: t('products.common.buyNow'),
      link: 'https://stan.store',
    },
    {
      id: 6,
      category: 'products',
      title: t('products.items.m6.title'),
      desc: t('products.items.m6.desc'),
      price: '$17',
      image: 'https://readdy.ai/api/search-image?query=instagram%20captions%20social%20media%20copy%20writing%20digital%20download%20product%20purple%20pink%20modern%20phone%20screen&width=600&height=380&seq=prod10&orientation=landscape',
      cta: t('products.common.buyNow'),
      link: 'https://stan.store',
      badge: t('products.common.popular'),
    },
    {
      id: 7,
      category: 'workshops',
      title: t('products.items.m7.title'),
      desc: t('products.items.m7.desc'),
      price: '$67',
      image: 'https://readdy.ai/api/search-image?query=online%20workshop%20webinar%20live%20class%20digital%20business%20launch%20entrepreneur%20latina%20woman%20teaching%20screen&width=600&height=380&seq=prod5&orientation=landscape',
      cta: t('products.common.enroll'),
      link: 'https://stan.store',
      badge: t('products.items.m7.badge'),
    },
    {
      id: 8,
      category: 'workshops',
      title: 'Masterclass: Email Marketing',
      desc: t('products.items.m8.desc'),
      price: '$37',
      image: 'https://readdy.ai/api/search-image?query=email%20marketing%20masterclass%20digital%20course%20inbox%20automation%20funnel%20purple%20blue%20modern%20technology&width=600&height=380&seq=prod6&orientation=landscape',
      cta: t('products.common.enroll'),
      link: 'https://stan.store',
    },
    {
      id: 9,
      category: 'workshops',
      title: t('products.items.m9.title'),
      desc: t('products.items.m9.desc'),
      price: '$57',
      image: 'https://readdy.ai/api/search-image?query=personal%20branding%20workshop%20online%20class%20professional%20woman%20entrepreneur%20purple%20pink%20neon%20modern%20digital&width=600&height=380&seq=prod11&orientation=landscape',
      cta: t('products.common.enroll'),
      link: 'https://stan.store',
      badge: t('products.items.m9.badge'),
    },
    {
      id: 10,
      category: 'services',
      title: t('products.items.m10.title'),
      desc: t('products.items.m10.desc'),
      price: '$197',
      image: 'https://readdy.ai/api/search-image?query=one%20on%20one%20business%20consulting%20strategy%20session%20professional%20woman%20laptop%20video%20call%20modern%20office%20purple%20lighting&width=600&height=380&seq=prod7&orientation=landscape',
      cta: t('products.common.book'),
      link: 'https://stan.store',
      badge: 'Premium',
    },
    {
      id: 11,
      category: 'services',
      title: t('products.items.m11.title'),
      desc: t('products.items.m11.desc'),
      price: '$497/mo',
      image: 'https://readdy.ai/api/search-image?query=social%20media%20management%20service%20professional%20team%20content%20creation%20instagram%20facebook%20tiktok%20purple%20blue%20modern&width=600&height=380&seq=prod8&orientation=landscape',
      cta: t('products.common.hire'),
      link: 'https://stan.store',
    },
    {
      id: 12,
      category: 'services',
      title: t('products.items.m12.title'),
      desc: t('products.items.m12.desc'),
      price: '$797',
      image: 'https://readdy.ai/api/search-image?query=website%20design%20wix%20professional%20modern%20business%20landing%20page%20purple%20blue%20gradient%20laptop%20screen%20digital%20agency&width=600&height=380&seq=prod12&orientation=landscape',
      cta: t('products.common.hire'),
      link: 'https://stan.store',
    },
  ];

  const categories: { key: Category; label: string; icon: string }[] = [
    { key: 'all', label: t('products.categories.all'), icon: 'ri-apps-2-line' },
    { key: 'courses', label: t('products.categories.courses'), icon: 'ri-graduation-cap-line' },
    { key: 'products', label: t('products.categories.products'), icon: 'ri-download-cloud-line' },
    { key: 'workshops', label: t('products.categories.workshops'), icon: 'ri-live-line' },
    { key: 'services', label: t('products.categories.services'), icon: 'ri-briefcase-line' },
  ];

  const filtered = activeCategory === 'all'
    ? products
    : products.filter((p) => p.category === activeCategory);

  return (
    <div className="min-h-screen bg-[#030006] text-white">
      {/* Hero */}
      <section className="relative pt-36 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_30%_20%,rgba(140,82,255,0.18)_0%,transparent_60%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_70%_80%,rgba(0,194,255,0.10)_0%,transparent_60%)]" />
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center relative z-10">
          <p className="text-[#FF2DAA] text-xs font-bold uppercase tracking-widest mb-4">{t('products.hero.badge')}</p>
          <h1 className="text-4xl md:text-6xl font-black mb-6 leading-tight">
            {t('products.hero.titlePrefix')}{' '}
            <span className="bg-gradient-to-r from-[#8c52ff] via-[#FF2DAA] to-[#00c2ff] bg-clip-text text-transparent">
              {t('products.hero.titleHighlight')}
            </span>
          </h1>
          <p className="text-white/60 text-lg max-w-2xl mx-auto leading-relaxed">
            {t('products.hero.subtitle')}
          </p>
        </div>
      </section>

      {/* Filter Tabs */}
      <section className="sticky top-20 z-40 bg-[#030006]/90 backdrop-blur-xl border-b border-white/8 py-4">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex items-center gap-2 overflow-x-auto pb-1 scrollbar-hide">
            {categories.map((cat) => (
              <button
                key={cat.key}
                onClick={() => setActiveCategory(cat.key)}
                className={`whitespace-nowrap flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 cursor-pointer flex-shrink-0 ${
                  activeCategory === cat.key
                    ? 'bg-gradient-to-r from-[#8c52ff] to-[#FF2DAA] text-white'
                    : 'bg-white/5 border border-white/10 text-white/60 hover:text-white hover:border-white/30'
                }`}
              >
                <i className={`${cat.icon} text-base`} />
                {cat.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <p className="text-white/30 text-sm mb-8">
            {filtered.length} {filtered.length === 1 ? t('products.grid.foundSingle') : t('products.grid.foundPlural')}
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filtered.map((product) => (
              <div
                key={product.id}
                className="group relative bg-white/3 border border-white/8 rounded-2xl overflow-hidden hover:border-[#8c52ff]/40 transition-all duration-500 hover:-translate-y-2 flex flex-col"
              >
                {product.badge && (
                  <div className="absolute top-3 left-3 z-10 bg-gradient-to-r from-[#8c52ff] to-[#FF2DAA] text-white text-xs font-bold px-3 py-1 rounded-full">
                    {product.badge}
                  </div>
                )}
                <div className="relative h-48 overflow-hidden flex-shrink-0">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#030006] via-transparent to-transparent" />
                  <div className="absolute top-3 right-3 bg-black/60 backdrop-blur-sm border border-white/10 rounded-full px-3 py-1">
                    <span className="text-[#00c2ff] font-black text-sm">{product.price}</span>
                  </div>
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="mb-1">
                    <span className="text-[#8c52ff] text-xs font-semibold uppercase tracking-wider">
                      {categories.find((c) => c.key === product.category)?.label}
                    </span>
                  </div>
                  <h3 className="text-white font-bold text-base leading-tight mb-2">{product.title}</h3>
                  <p className="text-white/50 text-xs leading-relaxed mb-5 flex-1">{product.desc}</p>
                  <a
                    href={product.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="whitespace-nowrap w-full flex items-center justify-center gap-2 bg-gradient-to-r from-[#8c52ff] to-[#00c2ff] text-white text-sm font-semibold py-2.5 rounded-xl hover:opacity-90 transition-opacity duration-300 cursor-pointer"
                  >
                    {product.cta}
                    <i className="ri-external-link-line text-xs" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-[#8c52ff]/10 via-transparent to-[#00c2ff]/10" />
        <div className="max-w-3xl mx-auto px-4 md:px-8 text-center relative z-10">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4">
            {t('products.footerCta.title')}
          </h2>
          <p className="text-white/60 mb-8 text-lg">
            {t('products.footerCta.subtitle')}
          </p>
          <a
            href="https://stan.store"
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-gradient-to-r from-[#8c52ff] to-[#FF2DAA] text-white font-bold px-8 py-4 rounded-full hover:opacity-90 transition-opacity duration-300 cursor-pointer text-base"
          >
            <i className="ri-calendar-line" />
            {t('products.footerCta.cta')}
          </a>
        </div>
      </section>
    </div>
  );
};

export default ProductsPage;
